<template>
    <div class="apprentice-simple-card">
        <h3 class="title">{{ $t('user_account.notifications') }}</h3>
        <div class="description">{{ $t('user_account.please_indicate_your_preference_for_notifications_below') }}</div>

        <div
            class="notification-setting"
            v-if="!this.$authUser.isStudent() && userType !== 'organization'">
            <div class="notification-name">
                <b-form-checkbox
                    class="statusmail"
                    v-model="status_mail"
                    name="checkbox-1"
                    :value="1"
                    :unchecked-value="0"
                    @change="onSubmit"
                    switch>
                </b-form-checkbox>
                <span class="label">{{ $t('user_account.status_emails_about_papers') }}</span>
            </div>
            <div class="short-description">
                {{ $t('user_account.receive_an_email_every_week_about_the_status_of_the_papers_you_linked_to') }}.
            </div>
        </div>

        <div
            class="notification-setting"
            v-if="userType !== 'organization'">
            <div class="notification-name">
                <b-form-checkbox
                    class="notifications"
                    v-model="notifications"
                    name="checkbox-1"
                    :value="1"
                    :unchecked-value="0"
                    @change="onSubmit"
                    switch>
                </b-form-checkbox>
                <span class="label">{{ $t('user_account.notification_mails') }}</span>
            </div>

            <div class="short-description">
                {{ $t('user_account.receive_email_warnings') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-user-settings-component',
    props: ['userIn', 'userType'],
    data() {
        return {
            user: this.userIn,
            darkmode: 1,
            status_mail: this.userIn.mail_settings ? this.userIn.mail_settings.status_mail : 1,
            notifications: this.userIn.mail_settings ? this.userIn.mail_settings.notifications : 1,
        };
    },
    methods: {
        onSubmit() {
            const body = document.documentElement;
            this.$cookie.set('theme-settings', this.darkmode, '30d');

            if (this.darkmode) {
                body.setAttribute('data-theme', 'dark-theme');
            } else {
                body.setAttribute('data-theme', 'light-theme');
            }

            let data = {
                darkmode: this.darkmode,
                status_mail: this.status_mail,
                notifications: this.notifications,
                initial_only: this.userIn.initial_only ? this.userIn.initial_only : 0,
            };

            this.alert.saving();

            this.axios.post(this.routes.userSettings(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.title {
    margin-bottom: map-get($grid-gutter-spacing, 'ten');
}

.description {
    margin-bottom: $grid-gutter-width;
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    font-size: $base-font-size;
}

.notification-setting {
    .notification-name {
        display: flex;
        flex-direction: row;
        column-gap: map-get($grid-gutter-spacing, 'five');
        align-items: center;

        .label {
            font-weight: $font-weight-bold;
            font-size: $base-font-size;
            margin-bottom: 0;
        }
    }

    &:not(:last-of-type) {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }
}

.short-description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    margin-left: 41px;
}
</style>
